// LUMINA · pages/vajra/components/DharmaRequestForm.jsx
// Phase 39D: extracted from VajraPortal.jsx — Task 12C 祈请表单

import React, { useState } from 'react';
import { API, GD, CR, DG, TXT, TXT2 } from '../constants';

export default function DharmaRequestForm({ token, member, requestTypes }) {
  const [selectedType, setSelectedType] = useState(null);
  const [form, setForm] = useState({
    requester_name:"", requester_email:"", requester_phone:"",
    subject_name:"", subject_info:"",
    birth_year:"", birth_month:"", birth_day:"", birth_hour:"", birth_gender:"M",
  });
  const [submitted, setSubmitted] = useState(false);
  const [err, setErr] = useState("");

  if (!selectedType) return (
    <div>
      <div style={{display:"flex",flexWrap:"wrap",gap:10}}>
        {requestTypes.map(rt => (
          <button key={rt.key} onClick={() => setSelectedType(rt)}
            style={{padding:"10px 18px",borderRadius:10,cursor:"pointer",textAlign:"left",
              border:"1px solid rgba(212,175,55,0.3)",background:"rgba(139,105,20,0.04)",
              minWidth:160}}>
            <div style={{fontSize:18,marginBottom:4}}>{rt.label_icon}</div>
            <div style={{fontSize:13,color:TXT,fontWeight:500}}>{rt.label_zh}</div>
            {rt.description && (
              <div style={{fontSize:11,color:TXT2,marginTop:4,lineHeight:1.6}}>
                {rt.description}
              </div>
            )}
          </button>
        ))}
      </div>
      {requestTypes.length === 0 && (
        <div style={{fontSize:13,color:TXT2}}>祈请服务准备中，敬请期待</div>
      )}
    </div>
  );

  if (submitted) return (
    <div style={{padding:"20px",background:"rgba(6,78,59,0.05)",borderRadius:10,
      border:"1px solid rgba(6,78,59,0.2)"}}>
      <div style={{fontSize:15,color:DG,marginBottom:8}}>✓ 祈请已提交</div>
      <div style={{fontSize:13,color:TXT2,lineHeight:1.8}}>
        感恩您的发心。上师将在适当时候为您回向，吉祥如意。
      </div>
      <button onClick={()=>{setSubmitted(false);setSelectedType(null);}}
        style={{marginTop:12,fontSize:12,color:GD,background:"none",border:"none",cursor:"pointer"}}>
        提交另一个祈请
      </button>
    </div>
  );

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    const body = {
      request_type_key: selectedType.key,
      requester_name:   form.requester_name,
      requester_email:  form.requester_email || null,
      requester_phone:  form.requester_phone || null,
      subject_name:     form.subject_name   || null,
      subject_info:     form.subject_info   || null,
      birth_year:  form.birth_year  ? parseInt(form.birth_year)  : null,
      birth_month: form.birth_month ? parseInt(form.birth_month) : null,
      birth_day:   form.birth_day   ? parseInt(form.birth_day)   : null,
      birth_hour:  form.birth_hour  ? parseInt(form.birth_hour)  : null,
      birth_gender: form.birth_gender || "M",
    };
    const h = token ? { Authorization:`Bearer ${token}`, "Content-Type":"application/json" }
                    : { "Content-Type":"application/json" };
    const r = await fetch(`${API}/vajra/requests`, {method:"POST",headers:h,body:JSON.stringify(body)});
    if (r.ok) setSubmitted(true);
    else { const d=await r.json().catch(()=>{}); setErr(d?.detail||"提交失败，请稍后重试"); }
  };

  return (
    <form onSubmit={submit}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20}}>
        <button type="button" onClick={()=>setSelectedType(null)}
          style={{fontSize:11,color:TXT2,background:"none",border:"none",cursor:"pointer"}}>
          ← 返回
        </button>
        <span style={{fontSize:15,color:TXT}}>
          {selectedType.label_icon} {selectedType.label_zh}
        </span>
      </div>

      {selectedType.extra_note && (
        <div style={{fontSize:12,color:TXT2,padding:"8px 12px",background:"rgba(0,0,0,0.03)",
          borderRadius:6,marginBottom:16,lineHeight:1.7}}>
          {selectedType.extra_note}
        </div>
      )}

      <div style={{marginBottom:12}}>
        <label style={{fontSize:11,color:GD,display:"block",marginBottom:4}}>您的法名/姓名 *</label>
        <input required value={form.requester_name}
          onChange={e=>setForm({...form,requester_name:e.target.value})}
          style={{width:"100%",padding:"8px 10px",borderRadius:6,fontSize:13,
            border:"1px solid rgba(212,175,55,0.35)",boxSizing:"border-box"}}/>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:11,color:GD,display:"block",marginBottom:4}}>
          联系方式（邮件或微信，选填）
        </label>
        <input value={form.requester_email} placeholder="邮箱或微信号"
          onChange={e=>setForm({...form,requester_email:e.target.value})}
          style={{width:"100%",padding:"8px 10px",borderRadius:6,fontSize:13,
            border:"1px solid rgba(212,175,55,0.35)",boxSizing:"border-box"}}/>
      </div>

      {selectedType.show_subject_name && (
        <div style={{marginBottom:12}}>
          <label style={{fontSize:11,color:GD,display:"block",marginBottom:4}}>
            {selectedType.subject_name_label || "祈请对象姓名（选填）"}
          </label>
          <input value={form.subject_name}
            onChange={e=>setForm({...form,subject_name:e.target.value})}
            style={{width:"100%",padding:"8px 10px",borderRadius:6,fontSize:13,
              border:"1px solid rgba(212,175,55,0.35)",boxSizing:"border-box"}}/>
        </div>
      )}
      {selectedType.show_subject_info && (
        <div style={{marginBottom:16}}>
          <label style={{fontSize:11,color:GD,display:"block",marginBottom:4}}>
            {selectedType.subject_info_label || "情况简述（选填）"}
          </label>
          <textarea value={form.subject_info} rows={3}
            onChange={e=>setForm({...form,subject_info:e.target.value})}
            style={{width:"100%",padding:"8px 10px",borderRadius:6,fontSize:13,
              border:"1px solid rgba(212,175,55,0.35)",boxSizing:"border-box",resize:"vertical"}}/>
        </div>
      )}

      <div style={{padding:"14px 16px",borderRadius:8,
        border:"1px solid rgba(212,175,55,0.2)",
        background:"rgba(253,251,247,0.8)",marginBottom:16}}>
        <div style={{fontSize:11,color:GD,letterSpacing:1,marginBottom:8}}>
          提供出生时间（选填）
        </div>
        <div style={{fontSize:11,color:TXT2,marginBottom:10,lineHeight:1.6}}>
          如您愿意，可帮助上师更准确了解您的能量状态与修行方向。
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
          {[["birth_year","年","1900","2010",4],
            ["birth_month","月","1","12",2],
            ["birth_day","日","1","31",2],
            ["birth_hour","时","0","23",2]].map(([k,label,min,max,size])=>(
            <div key={k} style={{display:"flex",alignItems:"center",gap:4}}>
              <span style={{fontSize:11,color:TXT2}}>{label}</span>
              <input type="number" min={min} max={max} value={form[k]}
                onChange={e=>setForm({...form,[k]:e.target.value})}
                style={{width:`${size*12}px`,padding:"4px 6px",borderRadius:4,fontSize:12,
                  border:"1px solid rgba(212,175,55,0.3)",textAlign:"center"}}/>
            </div>
          ))}
          <div style={{display:"flex",gap:12,fontSize:12,color:TXT2}}>
            {[["M","男"],["F","女"]].map(([v,label])=>(
              <label key={v} style={{cursor:"pointer"}}>
                <input type="radio" name="birth_gender" value={v}
                  checked={form.birth_gender===v}
                  onChange={()=>setForm({...form,birth_gender:v})}
                  style={{marginRight:4}}/>
                {label}
              </label>
            ))}
          </div>
        </div>
      </div>

      {err && <div style={{color:CR,fontSize:13,marginBottom:10}}>✗ {err}</div>}

      <button type="submit"
        style={{padding:"10px 28px",borderRadius:8,background:GD,color:"#fff",
          border:"none",fontSize:13,cursor:"pointer",letterSpacing:.5}}>
        提交祈请
      </button>
    </form>
  );
}
